import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

import { queryRelevanceTestDefinition, QUERY_KEY } from 'src/queries/queryRelevanceTestDefinition';

type TestDefinition = Models.IngestConfigApi.RelevanceTests.RelevanceTestDefinition;
type QueryKey = App.RelevanceTestDefinitions.DefinitionLookupQueryKey;

export const useQueryRelevanceTestDefinition = (
    accessToken: string | undefined | false,
    search: string,
    options?: UseQueryOptions<TestDefinition, Error, TestDefinition, QueryKey>,
): UseQueryResult<TestDefinition, Error> => useQuery<TestDefinition, Error, TestDefinition, QueryKey>(
    [QUERY_KEY, accessToken, search],
    queryRelevanceTestDefinition,
    options,
);
